import React from 'react';
import { Link } from 'react-router-dom';
import { categories } from '../data/mockData';
import { 
  Car, BookOpen, Briefcase, Baby, Monitor, Sparkles, 
  Shirt, Gamepad2, Heart, Gift, Home, Music, Cpu, Plane, Tag 
} from 'lucide-react';

const categoryIcons = {
  'auto': Car,
  'blog': BookOpen,
  'business': Briefcase,
  'children': Baby,
  'computers': Monitor,
  'cosmetics': Sparkles,
  'fashion': Shirt,
  'games': Gamepad2,
  'health-and-beauty': Heart,
  'holidays': Gift,
  'house': Home,
  'music-and-video': Music,
  'tech': Cpu,
  'travel': Plane,
  'uncategorized': Tag,
};

const categoryColors = [
  'from-[#345a83] to-[#345a83]',
  'from-pink-500 to-rose-500',
  'from-amber-500 to-orange-500',
  'from-emerald-500 to-teal-500',
  'from-[#345a83] to-cyan-500',
  'from-purple-500 to-fuchsia-500',
  'from-red-500 to-pink-500',
  'from-lime-500 to-green-500',
];

const CategoryGrid = () => {
  return (
    <section className="bg-white py-12">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <div className="text-center mb-10">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-slate-900 mb-3">
            Browse by Category
          </h2>
          <p className="text-slate-500 text-lg max-w-2xl mx-auto">
            Find the best deals across all your favorite shopping categories
          </p>
        </div>

        {/* Category Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
          {categories.map((category, index) => {
            const linkPath = category.slug === 'blog' 
              ? '/blog' 
              : `/category/${category.slug}`;
            
            const IconComponent = categoryIcons[category.slug] || Tag;
            const colorClass = categoryColors[index % categoryColors.length];
            
            return (
              <Link
                key={category.id}
                to={linkPath}
                className="group relative bg-slate-50 rounded-2xl p-6 text-center hover:bg-white hover:shadow-xl transition-all duration-300 border border-transparent hover:border-[#c5d5e8] animate-fadeInUp opacity-0"
                style={{ animationDelay: `${index * 0.03}s`, animationFillMode: 'forwards' }}
              >
                <div className={`w-14 h-14 bg-gradient-to-br ${colorClass} rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 group-hover:rotate-3 transition-all duration-300 shadow-lg`}>
                  <IconComponent className="w-7 h-7 text-white" />
                </div>
                <span className="text-slate-700 font-semibold group-hover:text-[#345a83] transition-colors block">
                  {category.name}
                </span>
                <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-[#345a83]/0 to-[#345a83]/0 group-hover:from-[#345a83]/5 group-hover:to-[#345a83]/5 transition-all duration-300"></div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CategoryGrid;
